import { useEffect, useRef } from "react";
import moment from "moment";
import { listsetting, downloadBackup } from "../../../services/admin";
import Swal from "sweetalert2";

const BackupScheduler = () => {
  const settingsRef = useRef(null);
  const lastTriggeredRef = useRef("");

  useEffect(() => {
    const temp = new FormData();
    if (localStorage.getItem("Role") !== "1") {
      temp.append("academy_id", localStorage.getItem("academy"));
    } else {
      temp.append("role_id", localStorage.getItem("Role"));
    }

    listsetting(temp).then((resp) => {
      if (resp?.status === true && resp.data?.backup_frequency && resp.data?.backup_time) {
        settingsRef.current = resp.data;
        checkAndBackup();
      }
    });

    const interval = setInterval(checkAndBackup, 60000);
    return () => clearInterval(interval);
  }, []);

  function checkAndBackup() {
    const settings = settingsRef.current;
    if (!settings) return;

    const now = moment();
    const currentTime = now.format("HH:mm");
    const minuteKey = now.format("YYYY-MM-DD HH:mm");

    if (settings.backup_time !== currentTime) return;
    if (lastTriggeredRef.current === minuteKey) return;

    let shouldBackup = false;
    switch (settings.backup_frequency) {
      case "daily":
        shouldBackup = true;
        break;
      case "weekly":
        shouldBackup = now.day() === 0; // Sunday
        break;
      case "monthly":
        shouldBackup = now.date() === now.daysInMonth(); // last day of month
        break;
      case "yearly":
        shouldBackup = now.month() === 11 && now.date() === 31; // Dec 31
        break;
      default:
        break;
    }

    if (!shouldBackup) return;

    lastTriggeredRef.current = minuteKey;

    Swal.fire({
      title: "Database Backup",
      html: "Backup is in progress, please wait...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading(),
    });

    const formData = new FormData();
    const academyId = settings.academy_id || "";
    formData.append("academy_id", academyId);
    const filename = `backup_academy${academyId}_${moment().format("YYYY-MM-DD_HH-mm-ss")}.sql.gz`;
    downloadBackup(formData).then((res) => {
      if (res?.status === true) {
        Swal.fire({
          icon: "success",
          title: "Backup Complete",
          html: `<p class="mb-2">Database backup downloaded successfully.</p>
                 <div style="background:#f4f6f9;padding:10px 14px;border-radius:6px;text-align:left;">
                   <span class="text-muted" style="font-size:12px;">Saved to</span><br/>
                   <span style="font-family:monospace;font-size:13px;word-break:break-all;">
                     <i class="fa fa-folder-open text-warning me-1"></i>
                     Downloads/<strong>${filename}</strong>
                   </span>
                 </div>`,
          confirmButtonColor: "#6259ca",
        });
      } else {
        Swal.fire({ icon: "error", title: "Backup Failed", text: "Could not generate the database backup. Please try again.", confirmButtonColor: "#6259ca" });
      }
    }).catch(() => {
      Swal.fire({ icon: "error", title: "Backup Failed", text: "Could not generate the database backup. Please try again.", confirmButtonColor: "#6259ca" });
    });
  }

  return null;
};

export default BackupScheduler;
